import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoadStatus } from '../../../store/state/shipment-load/models';
import { TransportOrderLoad } from '../../../store/state/shipment-transport-order/models';
import { Origin } from '../../../store/state/monitoring/transport/constants';
import { DeviationType } from '../../../store/models';
import { IconNames } from '../../../common/constants';

@Component({
  selector: 'ui-load-info-bar-header-default',
  templateUrl: './load-info-bar-header-default.component.html',
  styleUrls: ['./load-info-bar-header-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadInfoBarHeaderDefaultComponent {
  @Input() load: TransportOrderLoad;
  @Input() loadStatus: LoadStatus;
  @Input() hasLabel: boolean;
  @Input() hasSpeedUpInfo: boolean;
  @Input() hasRegion: boolean;

  deviationType = DeviationType;
  origin = Origin;
  iconNameList = IconNames;
}
